import Vue from 'vue'
Vue.component('NavBar', require('./components/Navbar.vue').default);
Vue.component('SideBar', require('./components/SideBar.vue').default);
Vue.component('FooterBar', require('./components/FooterBar.vue').default);
Vue.component('MainOtp', require('./components/MainOtp.vue').default);
Vue.component('ToogleMenu', require('./components/ToogleMenu.vue').default);
Vue.component('GuestPhoneNumber', require('./components/GuestPhoneNumber.vue').default);
Vue.component('BaseInput', require('./components/BaseInput.vue').default);
